import { render, staticRenderFns } from "./VehicleParticulars.vue?vue&type=template&id=2555c8e7"
import script from "./VehicleParticulars.vue?vue&type=script&lang=js"
export * from "./VehicleParticulars.vue?vue&type=script&lang=js"
import style0 from "./VehicleParticulars.vue?vue&type=style&index=0&id=2555c8e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports